import React from 'react';

import { IconTooltip } from 'utils/components/IconTooltip';

import './PortfolioSummaryChartHelp.scss';

export default function PortfolioSummaryChartHelp() {
    return (
        <IconTooltip className="PortfolioSummaryChartHelp" maxWidth={310}>
            <div>
                This chart is used to analyze the characteristics of a basket to
                assist in pre-trade analysis and ongoing monitoring. It displays
                the notional value in the base currency (set in the global
                settings) by a chosen grouping.
            </div>
            <div>
                The groupings are ordered by value, from highest at the top to
                lowest at the bottom.
            </div>
            <div>View by:</div>
            <div className="portfolio-summary-help-view-block side-net">
                <div>
                    <h1>Side</h1>
                    <h1>Net</h1>
                </div>
                <div className="bars">
                    <div className="side-bars">
                        <div className="bar buy">
                            <div className="traded" />
                            <div className="leaves" />
                        </div>
                        <div className="bar sell">
                            <div className="traded" />
                            <div className="leaves" />
                        </div>
                    </div>
                    <div className="net-bars">
                        <div className="bar net" />
                    </div>
                </div>
                <div>
                    <div>Buy and Sell breakdown</div>
                    <div>Net order (Sell - Buy)</div>
                </div>
            </div>
            <div className="portfolio-summary-help-view-block ordered">
                <div>
                    <div />
                    <div className="ordered-bars">
                        <div className="bar buy">
                            <div className="traded" />
                            <div className="leaves" />
                        </div>
                    </div>
                </div>
                <div>
                    <h1>Ordered</h1>
                    <h1>Traded</h1>
                    <h1>Leaves</h1>
                </div>
                <div className="descriptions">
                    <div>Total (Leaves and Traded)</div>
                    <div>Executed portion of order</div>
                    <div>Unexecuted portion of order</div>
                </div>
            </div>
            <div>
                In the global settings, Buys can be shown as positive, and
                Shorts and Sells can either be merged or split.
            </div>
        </IconTooltip>
    );
}
